import { render, staticRenderFns } from "./ClassifiedQuickSearchCategoryListMobile.vue?vue&type=template&id=48f4d6ef&"
import script from "./ClassifiedQuickSearchCategoryListMobile.vue?vue&type=script&lang=ts&"
export * from "./ClassifiedQuickSearchCategoryListMobile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports